import { createContext } from "react";

export default createContext({
  city: null,
  tab: [],
});
